export default __webpack_public_path__ + "static/img-conference-2023-f942eacffc26f163a01e488024d13da9.png";